export const NativeNull = null;
//# sourceMappingURL=native-null.const.mjs.map